<span class="error-snackbar-text"><i class="fa fa-check-circle-o"></i> {{message}}</span>
<!--<button mat-button class="mat-simple-snackbar-action"
        *ngIf="hasAction" (click)="dismiss()">{{action}}</button>-->